import {ICON_TYPES} from '../constants';

export const GridViewIcon = (): JSX.Element => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1528_1494)'>
        <path
          d='M5.5 5.5H0V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L5.5 0V5.5ZM1 4.5H4.5V1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V4.5Z'
          fill='#141414'
        />
        <path
          d='M12 5.5H6.5V0H10.5C10.8978 0 11.2793 0.158035 11.5607 0.43934C11.842 0.720644 12 1.10218 12 1.5V5.5ZM7.5 4.5H11V1.5C11 1.36739 10.9473 1.24021 10.8535 1.14645C10.7598 1.05268 10.6326 1 10.5 1H7.5V4.5Z'
          fill='#141414'
        />
        <path
          d='M5.5 12H1.5C1.10218 12 0.720644 11.842 0.43934 11.5607C0.158035 11.2794 0 10.8978 0 10.5L0 6.5H5.5V12ZM1 7.5V10.5C1 10.6326 1.05268 10.7598 1.14645 10.8535C1.24021 10.9473 1.36739 11 1.5 11H4.5V7.5H1Z'
          fill='#141414'
        />
        <path
          d='M10.5 12H6.5V6.5H12V10.5C12 10.8978 11.842 11.2794 11.5607 11.5607C11.2793 11.842 10.8978 12 10.5 12ZM7.5 11H10.5C10.6326 11 10.7598 10.9473 10.8535 10.8535C10.9473 10.7598 11 10.6326 11 10.5V7.5H7.5V11Z'
          fill='#141414'
        />
      </g>
      <defs>
        <clipPath id='clip0_1528_1494'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

GridViewIcon.iconType = ICON_TYPES.GRID_VIEW;
